/**
 * 个股详情页面分时图、K线图导航
 */
import React, { useState } from "react"
import "./index.less"
import { KCharts, TimeCharts } from "../../shared/charts"
import { quotedata } from "../quotedata"
import { ChartType } from "../../shared/utils"
import { PageBondType, PageType, StockSubType } from "../pagetype"
import { Observer } from "mobx-react-lite"

export function ChartTab(props: { quotedata: quotedata; pagetype: PageType; stocksubtype: StockSubType; bondsubtype?: PageBondType; reverseColor?:boolean}) {
  const [thisChartType, setThisChartType] = useState(ChartType.分时)
  const [thisSiderChartType, setThisSiderChartType] = useState(-1)
  const [siderTypeVisible, setSiderTypeVisible] = useState(false)
  const [siderActive, setSiderActive] = useState("")

  const defaultName = "分钟"
  let thisMainChartTypeList = [] as Array<ChartType>
  let thisSiderChartTypeList = [] as Array<ChartType>

  const clickMainTab = (name: any) => {
    setThisChartType(name)
    setThisSiderChartType(-1)
    setSiderActive("")
  }

  const clickSiderTab = () => {
    setSiderActive("active")
    if (siderTypeVisible) {
      setSiderTypeVisible(false)
    } else {
      setSiderTypeVisible(true)
    }
  }

  if (props.pagetype == PageType.沪深A股) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.英股) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.瑞士GDR) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.美股) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.外汇) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.全球指数) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.板块) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.沪深京指数   || props.pagetype == PageType.choice指数) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.人民币中间价) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.债券) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.港股) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.商品期货) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.国际期货) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.期货 && props.stocksubtype == StockSubType.金融期货) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.期权) {
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  } else if (props.pagetype == PageType.B股) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.场内基金) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if (props.pagetype == PageType.全球债券) {
    thisMainChartTypeList = [ChartType.分时, ChartType.五日, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = [ChartType["5分钟"], ChartType["15分钟"], ChartType["30分钟"], ChartType["60分钟"]]
  } else if(props.pagetype == PageType.未知){
    thisMainChartTypeList = [ChartType.分时, ChartType.日K, ChartType.周K, ChartType.月K]
    thisSiderChartTypeList = []
  }

  const getSmallScreenMinuteTabClass = () => {
    if (window.innerWidth < 330) {
      return "small-screen-selected-minute"
    } else {
      return ""
    }
  }

  return (
    <Observer>
      {() => (
        <>
          <ul className="comm-tabs">
            {thisMainChartTypeList.map((name: any) => {
              return (
                <li
                  key={name}
                  className={thisSiderChartType > 0 || siderActive ? "" : thisChartType == name ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault(), setSiderTypeVisible(false), clickMainTab(name)
                  }}
                >
                  <a href="#">{ChartType[name]}</a>
                </li>
              )
            })}
            {thisSiderChartTypeList.length > 0 && (
              <li className={`${(thisSiderChartTypeList.some((v) => v == thisSiderChartType) ? "active" : "") || siderActive}`}>
                <a href="#">
                  <div
                    className="selector"
                    onClick={(e) => {
                      e.preventDefault()
                      clickSiderTab()
                    }}
                  >
                    {ChartType[thisSiderChartType] ?? defaultName}
                  </div>
                  {siderTypeVisible && (
                    <ul className={`selector-items ${getSmallScreenMinuteTabClass()}`}>
                      {thisSiderChartTypeList.map((name: any) => {
                        return (
                          <li
                            key={name}
                            className={name == thisSiderChartType ? "selected" : ""}
                            onClick={(e) => {
                              e.preventDefault()
                              setThisSiderChartType(name)
                              setSiderTypeVisible(false)
                            }}
                          >
                            {ChartType[name]}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </a>
              </li>
            )}
          </ul>
          {thisSiderChartType > 0 ? (
            <KCharts quotedata={props.quotedata} charttype={thisSiderChartType} pagetype={props.pagetype} stocksubtype={props.stocksubtype} bondsubtype={props.bondsubtype} reverseColor={props.reverseColor}/>
          ) : thisChartType == ChartType.分时 || thisChartType == ChartType.五日 ? (
            <TimeCharts quotedata={props.quotedata} charttype={thisChartType} pagetype={props.pagetype} stocksubtype={props.stocksubtype} bondsubtype={props.bondsubtype} reverseColor={props.reverseColor}/>
          ) : (
            <KCharts quotedata={props.quotedata} charttype={thisChartType} pagetype={props.pagetype} stocksubtype={props.stocksubtype} bondsubtype={props.bondsubtype} reverseColor={props.reverseColor}/>
          )}
        </>
      )}
    </Observer>
  )
}
